import {
	LOAD_NEIGHBORS
} from './changeNodeConstants';

export const loadStations = () => ({
	type: LOAD_NEIGHBORS
});

